import { z } from "@/zod";
import { ulid, dateTime } from "@/schemas/commonFields";

export const commentReadSchema = z.object({
  id: ulid,
  comment: z.string(),
  created_at: dateTime,
  author_name: z.string(),
  author_role_name: z.string().optional(),
});

export const commentReadSchemaReadonly = commentReadSchema.readonly();

export type CommentRead = z.infer<typeof commentReadSchemaReadonly>;
